import { useEffect, useRef, useState } from 'react';
import { addDoc, collection, doc, getDoc, setDoc } from '@firebase/firestore';
import { db } from './firebase';
import ReactPlayer from 'react-player';
import { localize } from './localization';


function LetterScreen() {

    const [letter, setLetter] = useState(null);
    const [fontSize, setFontSize] = useState(16);
    const [preview, setPreview] = useState(false);
    const [playing, setPlaying] = useState(false);
    const [musicUrl, setMusicUrl] = useState(null);
    const hasReportedMusicError = useRef(false);

    var openEnvelope = () => {
        const envelope = document.querySelector('.envelope-wrapper');
        const heart = document.querySelector('.heart');
        const isOpen = envelope.classList.contains("flap");

        if (isOpen) return;
        if (musicUrl) {
            // ReactPlayer starts playback once its provider is ready. This also
            // supports every provider ReactPlayer accepts, not just YouTube.
            setPlaying(true);
        }
        heart.classList.remove("animate-flicker");
        envelope.classList.add("flap");
        setTimeout(() => envelope.classList.add("letter-off"), 2500);

    }

    var fetchLetter = async () => {
        const letterId = window.location.pathname.substring(1);
        const urlParams = new URLSearchParams(window.location.search);

        setPreview(urlParams.get("preview") === "true");

        var letter = (await getDoc(doc(db, "Letters", letterId))).data();
        letter.id = letterId;

        if (!letter) {
            alert(localize("letter_not_found", letter.locale));
            return;
        }

        var code = urlParams.get("code") ?? null;
        var askedForCode = false;

        while (code !== letter.code) {
            askedForCode = true;
            code = prompt(localize("security_code", letter.locale));
        }

        if (askedForCode) {
            await handleLetterSeen(letter);
        }

        var letterProps = (await getDoc(doc(db, "LetterProps", letterId))).data();

        setMusicUrl(letterProps.musicUrl);
        hasReportedMusicError.current = false;

        var bgColor = letterProps.letterColor.backgroundColor;
        document.documentElement.style.setProperty('--bg-color', `rgb(${bgColor.red * 255}, ${bgColor.green * 255}, ${bgColor.blue * 255})`);

        var heartColor = letterProps.letterColor.heartColor;
        document.documentElement.style.setProperty('--heart-color', `rgb(${heartColor.red * 255}, ${heartColor.green * 255}, ${heartColor.blue * 255})`);

        var paperColor = letterProps.letterColor.paperColor;
        document.documentElement.style.setProperty('--paper-color', `rgb(${paperColor.red * 255}, ${paperColor.green * 255}, ${paperColor.blue * 255})`);

        var textColor = letterProps.letterColor.textColor;
        document.documentElement.style.setProperty('--text-color', `rgb(${textColor.red * 255}, ${textColor.green * 255}, ${textColor.blue * 255})`);

        setTimeout(() => setLetter(letter), 500);
    }

    const handleLetterSeen = async (letter) => {
        if (!letter.seen) {
            letter.seen = true;
            await setDoc(doc(db, "Letters", letter.id), letter);
            let subject = localize("letter_seen_email_subject", letter.locale);
            var html = localize("letter_seen_email_html", letter.locale);
            html = html.replace("[0]", letter.from);
            html = html.replace("[1]", `${window.location.origin}/${letter.id}?code=${letter.code}`);
            if (letter.callbackEmail) {
                var email = {
                    "to": letter.callbackEmail,
                    "message": {
                        subject, html
                    }
                };
                await addDoc(collection(db, "Emails"), email);
            }
            //
        }
    }

    var blockSender = () => {
        if (window.confirm(localize("block_prompt", letter.locale))) {
            alert(localize("block_alert", letter.locale));
        }

    }

    var togglePlay = () => {
        if (musicUrl) {
            setPlaying(!playing);
        }

    }

    const handleMusicError = () => {
        setPlaying(false);

        if (!hasReportedMusicError.current && letter) {
            hasReportedMusicError.current = true;
            alert(localize("error_on_playing_music", letter.locale));
        }
    }

    useEffect(() => {
        fetchLetter();
    }, []);

    return (
        <div className="container">


            <ReactPlayer url={musicUrl}
                width={1}
                height={1}
                style={{ position: "fixed" }}
                playing={playing}
                loop={true}
                muted={false}
                volume={0.5}
                config={{ file: { attributes: { playsInline: true, }, }, }}
                playsinline={true}
                playsInline
                onPlay={() => setPlaying(true)}
                onPause={() => setPlaying(false)}
                onError={handleMusicError} />

            {letter !== null ? (<div className="envelope-wrapper" >
                <div className='controls'>
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <div>
                            <button onClick={() => setFontSize((fontSize * 1) + 2)}>
                                <i className="fa fa-search-plus" aria-hidden="true"></i>
                            </button>&nbsp;
                            <button onClick={() => setFontSize((fontSize * 1) - 2)}>
                                <i className="fa fa-search-minus" aria-hidden="true"></i>
                            </button>&nbsp;
                            <button onClick={() => togglePlay()}>
                                <i className={playing ? "fa fa-pause" : "fa fa-play"} aria-hidden="true"></i>
                            </button>
                        </div>
                        <div>
                            {
                                !preview ? (<button className='block-button' onClick={blockSender}>
                                    <i className="fa fa-ban" aria-hidden="true"></i>
                                </button>) : (<div></div>)
                            }
                        </div>
                    </div>
                </div>
                <div className="envelope" onClick={openEnvelope}>
                </div>
                <div className="heart animate-flicker" onClick={openEnvelope}></div>
                <div className="letter">
                    <div className="text" style={{ fontSize: fontSize + "px", lineHeight: (fontSize * 1 + 9) + "px" }}>
                        <strong>{letter.title}</strong>
                        <p >
                            {letter.body}
                        </p>
                        <p style={{ textAlign: "right" }}>{letter.from} </p>
                    </div>
                </div>
            </div>) : (<div className='loader'>

            </div>)}





        </div>
    );
}

export default LetterScreen;
